<template>
  <div class="relative sm:min-w-floatingLabelInputMinWidth select-none mb-sm">
    <input
      :type="computedInputType"
      :min="min"
      :step="step"
      :value="value"
      :aria-label="ariaLabel"
      :aria-invalid="hasError"
      @input="$emit('input', $event.target.value)"
      @focus="focusToggled"
      @blur="blurred"
      :placeholder="placeholderText"
      class="w-full p-5 leading-6 border-solid shadow-none outline-none py-base hover:border-placeholderGray focus:placeholder-transparent border-1 border-border rounded-6 focus:border-primary bg-whiteOverride"
      :class="[{ 'tw-border-error': hasError }, inputClasses]"
      data-test="input"
      @keydown="$emit('keydown', $event)"
    />
    <div
      v-if="showLabel"
      class="absolute inline-block bg-transparent text-10 top-2 left-5 rounded-6 text-primary"
      :class="{ 'text-warning2': hasError }"
      data-test="label"
    >
      <span>{{ placeholderText }}</span>
    </div>
    <button
      v-if="type === 'password'"
      @click="showPasswordToggled"
      type="button"
      class="absolute bg-transparent border-none text-border top-twenty right-xs hover:text-primary active:text-border"
      data-test="password-visibility-toggle"
      :aria-label="$t('forms.floatingLabelInput.revealPassword')"
      :aria-pressed="showPassword"
    >
      <EyeIcon class="cursor-pointer" />
    </button>
  </div>
</template>

<script>
import { EyeIcon } from '@/components/icons/fontIcons';

export default {
  name: 'FloatingLabelInput',
  components: {
    EyeIcon,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    min: {
      type: Number,
      required: false,
    },
    step: {
      type: Number,
      required: false,
    },
    fieldIsRequired: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
    },
    hasError: {
      type: Boolean,
    },
    ariaLabel: {
      type: String,
      required: false,
    },
    inputClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hasFocus: false,
      showPassword: false,
    };
  },
  computed: {
    computedInputType() {
      return this.type === 'password' ? this.passwordInput : this.type;
    },
    passwordInput() {
      return this.showPassword ? 'text' : 'password';
    },
    showLabel() {
      return !!(this.hasFocus || this.value);
    },
    placeholderText() {
      return this.fieldIsRequired ? `${this.placeholder} *` : this.placeholder;
    },
  },
  methods: {
    blurred(event) {
      this.hasFocus = false;
      this.$emit('blur', event.target.value);
    },
    focusToggled(event) {
      this.hasFocus = !this.hasFocus;
      this.$emit('focus', event.target.value);
    },
    showPasswordToggled() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
::-ms-reveal {
  display: none;
}
</style>
